import 'angular:locale/data:en';
import 'angular:locale/data:pt';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
